import React, { useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import get from 'lodash/get';

// STYLES
import styles from './output.module.scss';
import clsx from 'clsx';

// MAIN COMPONENT
const Output = ({
  name,
  plaintext
}) => {

  // FORMIK CONTEXT
  const { values } = useFormikContext() || {};

  const { value = '' } = useMemo(
    () => ({
      value: get(values, name)
    }),
    [name, values]
  )

  // RENDER
  return !name ? null : <div className={clsx(
    styles.output,
    plaintext && styles.plaintext
  )}>{String(value === undefined || value === '' ? 'BLANK' : value)}</div>;
}

// EXPORT
export default Output;
